import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { TabsComponent } from './../tabs/tabs.component';
import { TabComponent } from './../tabs/tab.component';
import { DynamicTabsDirective } from './../tabs/dynamic-tabs.directive';
import { MytabComponent } from './mytab.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Select2Module } from 'ng2-select2';
// import {Ng2TagsInputModule} from 'ng2-tagsinput';
import { ModalModule } from 'ngx-bootstrap/modal';
import { DetailComponent } from '../../pages/admin/icontact/tabs/detail.component';
import { DetailTicketComponent } from '../../pages/admin/icontact/tabs/ticket/detail_ticket.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { DetailUserComponent } from '../../pages/admin/icontact/tabs/user/detail_user.component';
import { FocusModule } from 'angular2-focus';
import { DetailOrganizeComponent } from '../../pages/admin/icontact/tabs/organize/detail_organize.component';
import { PopoverModule } from 'ngx-popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { IContactModule } from '../../pages/admin/icontact/iContactModule';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { AppTagsInputModule } from 'app/common/tags-input/tags-input.module';
import { ComponentsModule } from '../../components/component.module';

@NgModule({
  declarations: [
    MytabComponent,
    TabsComponent,
    TabComponent,
    DynamicTabsDirective,
    // TicketComponent
    DetailComponent,
    DetailTicketComponent,
    DetailUserComponent,
    DetailOrganizeComponent,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    Select2Module,
    // Ng2TagsInputModule,
    ModalModule.forRoot(),
    BsDatepickerModule.forRoot(),
    FocusModule.forRoot(),
    PopoverModule,
    TooltipModule.forRoot(),
    IContactModule,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    AppTagsInputModule.forRoot(),
    ComponentsModule,
  ],
  providers: [],
  bootstrap: [MytabComponent],
  // register the dynamic components here
  entryComponents: [TabComponent],
  exports: [MytabComponent],
})
export class MytabModule {}



// WEBPACK FOOTER //
// ./src/app/layout/mytab/mytab.module.ts